<template>
    <Modal v-model="modal"
           :title="title"
           :mask-closable="false"
           :loading="loading"
           :ok-text="$t(loading ? '确定':'导出中')"
           @on-ok="submit"
           @on-cancel="modal = false"
           width="600">
        <Form ref="form"
              :model="formData"
              :rules="rules"
              :label-colon="true"
              :label-width="120">
            <FormItem :label="$t('导出内容')"
                      prop="exportType">
                <RadioGroup v-model="formData.exportType">
                    <Radio label="current">
                        {{$t('最近一个月')}}
                        <Tooltip :content="$t('例如：当前时间2021年10月13日，最近一个月就是2021年9月1日到2021年9月30日')"
                                 theme="light"
                                 placement='right'>
                            <i class="icon-prompt-1-o tips-style"
                               style="color:#2d8cf0;"></i>
                        </Tooltip>
                    </Radio>
                    <Radio label="month">
                        {{$t('指定月份')}}
                        <Tooltip :content="$t('导出选定账期内所有客户或指定客户的数据')"
                                 theme="light"
                                 placement='right'>
                            <i class="icon-prompt-1-o tips-style"
                               style="color:#2d8cf0;"></i>
                        </Tooltip>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <template v-if="formData.exportType === 'month'">
                <FormItem v-if="showCustomer"
                          :label="$t('客户名称')"
                          prop="customerName">
                    <Input v-model="formData.customerName"
                           style="width: 250px" />
                </FormItem>
                <FormItem :label="$t('使用时间')"
                          prop="currTime">
                    <DatePicker v-model="formData.currTime"
                                type="month"
                                :editable="false"
                                :options="timeOption"
                                style="width: 250px" />
                </FormItem>
            </template>
        </Form>
    </Modal>
</template>
<script>
import { formatDateTime } from '@/service/utils'
export default {
    name: 'exportModal',
    props: {
        showCustomer: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            modal: false,
            loading: true,
            title: '',
            api: '',
            timeOption: {
                disabledDate (date) { // 限制当前月及以前
                    return date.valueOf() > Date.now()
                }
            },
            formData: {
                exportType: 'current',
                customerName: '',
                currTime: ''
            },
            rules: {
                currTime: { required: true, type: 'date', message: this.$t('该字段不能为空'), trigger: 'change' }
            }
        }
    },
    computed: {
    },
    methods: {
        changeLoading () {
            this.loading = false
            this.$nextTick(() => {
                this.loading = true
            })
        },
        open ({ title, api }) {
            this.title = title
            this.api = api
            this.modal = true
        },
        cancel () {
            this.modal = false
        },
        submit () {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    this.changeLoading()
                    return
                }

                const { exportType, currTime } = this.formData
                const params = { exportType }

                if (exportType === 'month') {
                    Object.assign(params, {
                        groupByFlag: 'cycle',
                        specifiMonth: currTime ? formatDateTime(currTime).substring(0, 7) : ''
                    })
                }

                this.axios.get(this.api, { params }).then(res => {
                    if (res.status) {
                        this.cancel()
                    }
                }).catch(e => {
                    this.changeLoading()
                })
            })
        }
    },
    watch: {
        modal (val) {
            if (!val) {
                this.$refs.form.resetFields()
                this.formData = {
                    exportType: 'current',
                    customerName: '',
                    currTime: ''
                }
            }
        }
    }
}
</script>
